import type { SvgIconProps } from "ui/icons/SVGIcon";
import SVGIcon from "ui/icons/SVGIcon";

export default function IconWarning(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.26795 1C8.03775 -0.333333 9.96225 -0.333333 10.7321 1L17.6603 13C18.4301 14.3333 17.4678 16 15.9282 16H2.0718C0.532197 16 -0.430054 14.3333 0.339746 13L7.26795 1Z"
        fill="#F0C051"
      />
      <path d="M9 10V4" stroke="#3D3D3D" strokeWidth="2" />
      <path d="M9 14V12" stroke="#3D3D3D" strokeWidth="2" />
    </SVGIcon>
  );
}
